module.exports = __webpack_public_path__ + "img/m2_en.5f1fd0e.jpg";